import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoCallOutline, IoLogoFacebook } from "react-icons/io5";
import styles from "../../../assets/css/PatientUI/assesmentResult.module.css";
import { Btn } from "../../UI/Button";
import { Share } from "../../../assets/icons/Share";
import { Download } from "../../../assets/icons/Download";
import { Link } from "react-router-dom";
import { jsPDF } from "jspdf";
import { useAuth } from "../../../Auth/AuthProvider";

import { docdata } from "./template/Template";
import { Dialog, DialogTitle } from "@mui/material";
import { AiOutlineMail, AiOutlineWhatsApp } from "react-icons/ai";
import { TbBrandLinkedin } from "react-icons/tb";
import { RiFacebookCircleLine } from "react-icons/ri";

import {
  get_Report,
  share_Report_Email,
} from "../../../services/patient/assessmentShare";
import { CircularProgress } from "../../../../node_modules/@mui/material/index";
import toast, {
  Toaster,
} from "../../../../node_modules/react-hot-toast/dist/index";
import { TEXT } from "../../../Samvenda-Admin/contant/constant";
import { NAVIGATE } from "../../../Samvenda-Admin/contant/NavigationConstant";
import axios from "../../../config/axiosConfig";
import Modal from "../../../Component/UI/ServicesCard/Modal";

import {
  FacebookShareButton,
  WhatsappShareButton,
  EmailShareButton,
  LinkedinShareButton,
} from "react-share";
import { useEffect } from "react";
import { Cross } from "../../../assets/icons/Cross";
import ConsentPopup from "../../../Component/UI/ServicesCard/ConsentPopup";
import ModalSuccess from "../../../Component/UI/ServicesCard/ModalSuccess";
import { counsellor } from "../../../Component/UI/ServicesCard/speaktocounsellorid";
export const Content = ({ headingStyle, large, data, level, seeResults }) => {
  const authCtx = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [idExist, setIdExist] = useState(false);
  const [passServiceData, setPassServiceData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenSuccess, setIsOpenSuccess] = useState({open:false});
  const [disable, setDisable] = useState(false);

  const [reportLink, setReportLink] = useState("");
  let shareContent = "";

  switch (data?.id) {
    case 1:
      shareContent =
        "Hi there ! I just took a Dementia Self- Assessment, I invite you. Try this for you and your family members this is really helpful.";
      break;
    default:
      shareContent =
        "Hi there ! I have started taking care of my mental wellbeing, I invite you to take care of yours with Samvedna MAP. It really helps me to stay on top of my self-care journey.";
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [isOpenConstent, setIsOpenConstent] = useState({
    open:false, 
    consent : false
  });

  console.log(idExist, 'idExist')

  const descriptionStyle = large
    ? { fontSize: "16px", lineHeight: "24px" }
    : null;
  const btnWidth = large ? "120px" : null;

  const content = data?.scoring?.scoring_list?.filter(
    (i) => i.level === "level " + level
  );

  const IfIdExist = (data) => {
    setPassServiceData(data);
    setIdExist(true);
  };

  const onClickSpeakToCounsellor = () => {
    try {
      axios.get(`/customer/services?assessment_id=${data.id}`).then((res) => {
        if (`${res.data.status}` === TEXT.STATUSTRUE) {
          const getIdForSpeakToCouns = res.data.list?.filter((result) => {
            return result.name
              .toLowerCase()
              .includes(TEXT.SPEAKTOCOUNSELLOR.toLowerCase());
          });

          getIdForSpeakToCouns[0]?.name
            .toLowerCase()
            .includes(TEXT.SPEAKTOCOUNSELLOR.toLowerCase())
            ? IfIdExist(getIdForSpeakToCouns[0])
            : navigate(NAVIGATE.SERVICES, {
                state: { id: data?.id },
              });
        } else {
          navigate(NAVIGATE.SERVICES, {
            state: { id: data?.id },
          });
        }
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  const assessmentDataType = JSON.parse(
    data?.is_mapped?.assessment_data || "{}"
  );

  const downloadPDF = () => {
    if (data.id === 1 || data.id === 2 || data.id === 3) {
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });
      const assessmentData = docdata(
        data.id,
        level,
        assessmentDataType[1].assesment_for
      );
      const userName = authCtx.loginUser.customer.name
        .replace(/\b\w/g, (l) => l.toUpperCase())
        .replace(/([a-zA-Z])([A-Z])([a-z])/g, "$1 $2$3");
      const imageData =
        "data:image/png;base64,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";
      pdf.addImage(imageData, "PNG", 13, 5, 50, 18);
      pdf.setFontSize(12);
      pdf
        .setFont(undefined, "bold")
        .text("Samvedna Senior Care Recommendations", 20, 30);
      pdf.setFontSize(11);
      pdf.text(assessmentData.title, 20, 40);
      pdf.setFontSize(10);
      pdf.setFont(undefined, "bold").text(assessmentData.level, 20, 50);
      pdf.setFont(undefined, "normal");
      pdf.text("Dear " + userName + ",", 20, 60);
      pdf.text(assessmentData.intro, 20, 65, { maxWidth: 170 });
      pdf.text(assessmentData.subHeading, 20, 75);
      pdf.setFont(undefined, "bold").text(assessmentData.optionHeading, 20, 85);
      pdf.setFont(undefined, "normal");
      let topSpacing = 95;
      assessmentData.points.map((point, index) => {
        const dime = pdf.getTextDimensions(point, { maxWidth: 170 });
        pdf.text(index + 1 + ". " + point, 20, topSpacing, { maxWidth: 170 });
        topSpacing += 4 * Math.ceil(dime.h / 3);
      });
      if (assessmentData.bottom) {
        const dime = pdf.getTextDimensions(assessmentData.bottom, {
          maxWidth: 170,
        });
        pdf.text(assessmentData.bottom, 20, topSpacing, {
          maxWidth: 170,
        });
        topSpacing += 4 * Math.ceil(dime.h / 3);
      }
      pdf.setFontSize(9);
      pdf.setFont(undefined, "bold");
      pdf.text(
        "Please note you can retake your self assessment after a period of one month.",
        20,
        topSpacing
      );
      pdf.setFont(undefined, "normal");
      pdf.text(
        "The information contained in this report, associated e-mail and any other attached documents is private & confidential and may not be used for medico-legal purposes.",
        20,
        280,
        { maxWidth: 170 }
      );
      pdf.save(`${data.name + "_result_level_" + level}.pdf`);
    }
  };

  const getPdfLink = () => {
    const payload = {
      assessment_id: data.id,
      level: level,
      // type: assessmentDataType[1].assesment_for,
      type: data?.is_mapped?.assessment_for,
      customer_id: data?.is_mapped?.customer_id,
    };
    get_Report(payload).then((res) => {
      res.data.status && setReportLink(res.data.list);
    });
  };

  const share = () => {
    getPdfLink();
    setTimeout(() => {
      handleClickOpen();
    }, 300);
  };

  useEffect(() => {
    getPdfLink();
  }, []);

  const downloadPdfBackend = () => {
    window.open(reportLink);
  };

  const emailShare = () => {
    setDisable(true);
    const payload = {
      assessment_id: data.id,
      level: level,
      type: assessmentDataType[1].assesment_for,
    };
    share_Report_Email(payload)
      .then((response) => {
        setDisable(false);
        setOpen(false);
        toast.success("Report shared successfully!");
      })
      .catch((i) => {
        console.log(i);
        setDisable(false);
        // toast.success("Report shared successfully!");
      });
  };

  return (
    <>

              {
                isOpenSuccess.open &&
                <ModalSuccess
                setIsOpenSuccess={setIsOpenSuccess}
                isOpenSuccess={isOpenSuccess}
                />
              }
     {
                isOpenConstent.open &&
                <ConsentPopup
                setIsOpenConstent = {setIsOpenConstent}
                isOpenConstent={isOpenConstent}
                setIsOpen = {setIdExist}
                isLoading = {isLoading}
               
                />
              }

      {idExist && 
      <Modal 
      setIsOpen={setIdExist} 
      modalData={passServiceData} 
      setIsOpenSuccess={setIsOpenSuccess}
      counsellorId={counsellor}
      isOpenConstent={isOpenConstent}
      setIsOpenConstent = {setIsOpenConstent}
      setIsLoading={setIsLoading}
      
      />}
      <div className={styles.content}>
        <Dialog
          fullWidth={true}
          maxWidth="xs"
          open={open}
          sx={{ paddingBottom: "10px" }}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>Share Report</div>
              <div style={{ cursor: "pointer" }} onClick={handleClose}>
                <Cross color="black" />
              </div>
            </div>
          </DialogTitle>
          <div style={{ margin: "10px 30px" }}>
            <FacebookShareButton
              url={reportLink}
              style={{ width: "100%" }}
              onShareWindowClose={handleClose}
              quote="Hi there ! I have started taking care of my mental wellbeing, I invite you to take care of yours with Samvedna MAP. It really helps me to stay on top of my self-care journey."
            >
              <Btn
                width={"100%"}
                color="#7A51AE"
                bgColor="transparent"
                variant="outlined"
                margin="5px 0"
                click={() => {
                  handleClose();
                }}
              >
                {<RiFacebookCircleLine size="22" />}
                <span style={{ marginLeft: "5px" }}>
                  Share report via Facebook
                </span>
              </Btn>
            </FacebookShareButton>
            <WhatsappShareButton
              url={reportLink}
              title={shareContent}
              separator=" - "
              style={{ width: "100%" }}
              onShareWindowClose={handleClose}
            >
              <Btn
                width={"100%"}
                color="#7A51AE"
                bgColor="transparent"
                variant="outlined"
                margin="5px 0"
              >
                {<AiOutlineWhatsApp size="22" />}
                <span style={{ marginLeft: "5px" }}>
                  Share report via Whatsapp
                </span>
              </Btn>
            </WhatsappShareButton>
            <LinkedinShareButton
              title="Assessment Report"
              summary={
                "Hi there ! I have started taking care of my mental wellbeing, I invite you to take care of yours with Samvedna MAP. It really helps me to stay on top of my self-care journey."
              }
              source="Samvedna Care"
              url={reportLink}
              style={{ width: "100%" }}
              onShareWindowClose={handleClose}
            >
              <Btn
                width={"100%"}
                color="#7A51AE"
                bgColor="transparent"
                variant="outlined"
                margin="5px 0"
              >
                {<TbBrandLinkedin size="22" />}
                <span style={{ marginLeft: "5px" }}>
                  Share report via Linkedin
                </span>
              </Btn>
            </LinkedinShareButton>
            <EmailShareButton
              subject="Assessment Report"
              body={
                "Hi there ! I have started taking care of my mental wellbeing, I invite you to take care of yours with Samvedna MAP. It really helps me to stay on top of my self-care journey."
              }
              url={reportLink}
              style={{ width: "100%" }}
              separator=" - "
              onShareWindowClose={handleClose}
            >
              <Btn
                width={"100%"}
                color="#7A51AE"
                bgColor="transparent"
                variant="outlined"
                // disabled={disable}
                margin="5px 0"
                // click={() => {
                //   emailShare();
                // }}
              >
                {disable ? (
                  <CircularProgress
                    color={"inherit"}
                    sx={{ height: "20px", width: "20px" }}
                  />
                ) : (
                  <>
                    {<AiOutlineMail size="22" />}
                    <span style={{ marginLeft: "5px" }}>
                      Share report via Email
                    </span>
                  </>
                )}
              </Btn>
            </EmailShareButton>
          </div>
        </Dialog>

        <h2 style={headingStyle}>{content?.[0]?.title}</h2>
        <p style={descriptionStyle}>{content?.[0]?.description}</p>
        {seeResults ? (
          <Link
            to="/patient/assessment/results"
            state={{ data }}
            style={{ textDecoration: "none" }}
          >
            <div style={{ textAlign: "center" }}>
              <Btn width="160px" variant="contained">
                See Results
              </Btn>
            </div>
          </Link>
        ) : (
          <div className={styles.buttons}>
            <Btn
              width={btnWidth}
              color="#7A51AE"
              bgColor="transparent"
              variant="outlined"
              click={share}
              disabled={disable}
            >
              <Share /> <span style={{ marginLeft: "5px" }}>Share</span>
            </Btn>
            <Btn
              width={btnWidth}
              color="#7A51AE"
              bgColor="transparent"
              variant="outlined"
              click={downloadPdfBackend}
            >
              {<Download />} <span style={{ marginLeft: "5px" }}>Download</span>
            </Btn>

            <Btn
              variant="contained"
              width="250px"
              height="37px"
              bgColor="#ff5a5a"
              click={onClickSpeakToCounsellor}
            >
              <IoCallOutline size={18} />
              <span style={{ marginLeft: "5px" }}>Speak to our Counsellor</span>
            </Btn>
          </div>
        )}
      </div>
    </>
  );
};
